module.exports = __webpack_public_path__ + "img/grand-cancun-pool.5f878dcb.jpg";